<div class="content-block">
    <Form>
        <slot/>
        <FormSection {title} {description}>
            <Combobox
                label="{selectYourSchoolOrSite}"
                enableAutoComplete={true}
                hasError={!selectedOrganisation && isSubmitButtonPressed}
                {errorMessage}
                bind:selected={selectedOrganisation}
                {dataProvider}
            />
            {#if submitButtonType === 'primary' }
                <Button type="primary" large text="{buttonText}" on:click={goToSelectedOrganisation} />
            {/if}
        </FormSection>
    </Form>
    {#if submitButtonType === 'secondary' }
        <div class={buttonCssClass}>
            <Button type="secondary" large text="{buttonText}" on:click={goToSelectedOrganisation} />
        </div>
    {/if}
</div>

<script>
    import { ComboboxDataProvider } from "./dataprovider.js";

    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import Combobox from "@itslearning/prometheus/assets/inputs/Combobox/v1/Combobox.svelte";
    import Form from '@itslearning/prometheus/assets/inputs/Form/v1/Form.svelte';
    import FormSection from "@itslearning/prometheus/assets/inputs/Form/v1/FormSection.svelte";

    export let title;
    export let description;
    export let selectYourSchoolOrSite;
    export let buttonText;
    export let redirectUrl;
    export let currentCustomerId;
    /** @type {('primary'|'secondary')} submitButtonType */
    export let submitButtonType = 'primary';
    export let buttonCssClass = '';
    export let errorMessage = '';

    export let kpiAction = null;
    let selectedOrganisation;
    let isSubmitButtonPressed = false;

    let dataProvider = new ComboboxDataProvider(currentCustomerId);

    async function goToSelectedOrganisation() {
        if (!selectedOrganisation)
        { 
            isSubmitButtonPressed = true;
            return;
        }

        if (kpiAction) {
            await kpiAction();
        }

        window.location.href = redirectUrl(selectedOrganisation);
    }
</script>
